import { produce } from "immer";
import * as Actions from "pages/Logs/store/logActions";
import * as logsActions from "pages/Logs/store/logsActions";

const initialState = {
  totalCount: 0,
  searchParams: null,
  openedRecipients: {}
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.SET_SEARCH_PARAMS:
      draft.searchParams = action.payload.searchParams;
      break;
    case logsActions.FETCH_LOGS_SUCCESS: {
      const payload = action.payload;
      draft.totalCount = payload.totalCount;
      break;
    }
    case Actions.SET_OPENED_RECIPIENTS: {
      const payload = action.payload;
      draft.openedRecipients = payload.openedRecipients;
      break;
    }

    default:
      break;
  }
}, initialState);

export default reducer;
